import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { TfrDetailsComponent } from '../tfr-details/tfr-details.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { AuthService } from '../../auth/auth/auth.service';
var TfrsComponent = /** @class */ (function () {
    function TfrsComponent(_dialog, _businessManagerService, _auth) {
        this._dialog = _dialog;
        this._businessManagerService = _businessManagerService;
        this._auth = _auth;
        this.isLoggedIn = false;
        this.isMember = false;
    }
    TfrsComponent.prototype.getActiveTFRs = function () {
        var _this = this;
        var activeTFRs = [];
        this.airport.tfrs.forEach(function (notam) {
            if (_this.getTFRStatus(notam) === 'ACTIVE') {
                activeTFRs.push(notam);
            }
        });
        activeTFRs.sort(function (a, b) { return a.effectiveDate.getTime() - b.effectiveDate.getTime(); });
        return activeTFRs;
    };
    TfrsComponent.prototype.getScheduledTFRs = function () {
        var _this = this;
        var scheduledTFRs = [];
        this.airport.tfrs.forEach(function (notam) {
            if (_this.getTFRStatus(notam) === 'SCHEDULED') {
                scheduledTFRs.push(notam);
            }
        });
        scheduledTFRs.sort(function (a, b) { return a.effectiveDate.getTime() - b.effectiveDate.getTime(); });
        return scheduledTFRs;
    };
    TfrsComponent.prototype.getTFRs = function () {
        var results = this.getActiveTFRs().concat(this.getScheduledTFRs());
        return results;
    };
    TfrsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this._auth.authenticated && this._auth.endUser)) return [3 /*break*/, 2];
                        this.isLoggedIn = true;
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isMember()];
                    case 1:
                        _a.isMember = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TfrsComponent.prototype.getTFRStatus = function (tfr) {
        var currentDate = new Date();
        if (tfr.expirationDate) {
            if (tfr.effectiveDate.getTime() < currentDate.getTime() && currentDate.getTime() < tfr.expirationDate.getTime()) {
                return 'ACTIVE';
            }
            else if (tfr.effectiveDate.getTime() > currentDate.getTime() && currentDate.getTime() < tfr.expirationDate.getTime()) {
                return 'SCHEDULED';
            }
            else {
                return 'EXPIRED';
            }
        }
        else {
            if (tfr.effectiveDate.getTime() < currentDate.getTime()) {
                return 'ACTIVE';
            }
            else if (tfr.effectiveDate.getTime() > currentDate.getTime()) {
                return 'SCHEDULED';
            }
            else {
                return 'ERROR';
            }
        }
    };
    TfrsComponent.prototype.showTFRDetails = function (tfr) {
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            tfr: tfr
        };
        var dialogRef = this._dialog.open(TfrDetailsComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
        });
    };
    return TfrsComponent;
}());
export { TfrsComponent };
